import { Component, OnInit } from '@angular/core';

import { PointageJournalier } from 'src/app/domain/RH/pointage-journalier';
import { PointagePause } from 'src/app/domain/RH/pointage-pause';
import { PointageService } from 'src/app/services/pointage.service';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { PointageBoxDialog } from 'src/app/tools/ui/pointage-box/pointage-box';
import * as _ from 'lodash'
import { Temporal } from '@js-temporal/polyfill';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-pointage',
    templateUrl: './pointage.component.html',
    styleUrl: './pointage.component.scss',
    standalone: true,
    imports: [MatFormFieldModule, FormsModule, MatInputModule, NgxMaterialTimepickerModule, MatButtonModule, MatIconModule, PreventDoubleClickDirective]
})
export class PointageComponent implements OnInit {
    public Model: PointageJournalier = new PointageJournalier();

    DefaultTime!: string;

    TimeDepartDomicile!: string
    TimeArriveeDomicile!: string
    TimeDebutJournee!: string
    TimeFinJournee!: string

    DepartDomicile!: Date
    ArriveeDomicile!: Date
    DebutJournee!: Date
    FinJournee!: Date

    constructor(
        private coreData: CoreData,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private pointageService: PointageService
    ) { }

    ngOnInit(): void {

        this.coreData.CurrentPageName = "Pointage";

        this.DefaultTime = `${Temporal.Now.plainDateTimeISO().hour}:${Temporal.Now.plainDateTimeISO().minute}`

        this.Model.DebutJournee = Temporal.Now.plainDateTimeISO();
        this.Model.FinJournee = Temporal.Now.plainDateTimeISO();

        this.pointageService.getPointage().subscribe(x => {
            if (x) {
                this.Model = x;
                if (this.Model.ArriveeDomicile)
                    this.TimeArriveeDomicile = `${this.Model.ArriveeDomicile.hour}:${this.Model.ArriveeDomicile.minute}`;
                if (this.Model.DebutJournee)
                    this.TimeDebutJournee = `${this.Model.DebutJournee.hour}:${this.Model.DebutJournee.minute}`;;
                if (this.Model.DepartDomicile)
                    this.TimeDepartDomicile = `${this.Model.DepartDomicile.hour}:${this.Model.DepartDomicile.minute}`;
                if (this.Model.FinJournee)
                    this.TimeFinJournee = `${this.Model.FinJournee.hour}:${this.Model.FinJournee.minute}`;
            }
        });

        this.getVehicule();
    }

    clearDepartDomicile() {
        this.TimeDepartDomicile = '';
        this.Model.DepartDomicile = undefined;
    }

    clearArriveeDomicile() {
        this.TimeArriveeDomicile = '';
        this.Model.ArriveeDomicile = undefined;
    }

    timeSetDepartDomicile(event: string) {
        const time = event.split(':');

        this.Model.DepartDomicile = Temporal.Now.plainDateTimeISO();
        this.DepartDomicile = new Date();
        this.DepartDomicile.setHours(Number(time[0]), Number(time[1]));
        this.Model.DepartDomicile = Temporal.PlainDateTime.from({ year: this.DepartDomicile.getFullYear(), day: this.DepartDomicile.getDate(), month: this.DepartDomicile.getMonth() + 1, hour: this.DepartDomicile.getHours(), minute: this.DepartDomicile.getMinutes() });
        this.setTimeDepartDomicile();
    }

    setTimeDepartDomicile() {
        this.TimeDepartDomicile = `${this.DepartDomicile.getHours()}:${this.DepartDomicile.getMinutes()}`;
    }

    timeSetArriveeDomicile(event: string) {
        const time = event.split(':');

        this.Model.ArriveeDomicile = Temporal.Now.plainDateTimeISO();
        this.ArriveeDomicile = new Date();
        this.ArriveeDomicile.setHours(Number(time[0]), Number(time[1]));
        this.Model.ArriveeDomicile = Temporal.PlainDateTime.from({ year: this.ArriveeDomicile.getFullYear(), day: this.ArriveeDomicile.getDate(), month: this.ArriveeDomicile.getMonth() + 1, hour: this.ArriveeDomicile.getHours(), minute: this.ArriveeDomicile.getMinutes() });
        this.setTimeArriveeDomicile();
    }

    setTimeArriveeDomicile() {
        this.TimeArriveeDomicile = `${this.ArriveeDomicile.getHours()}:${this.ArriveeDomicile.getMinutes()}`;
    }

    timeSetDebutJournee(event: string) {
        const time = event.split(':');

        this.DebutJournee = new Date();
        this.DebutJournee.setHours(Number(time[0]), Number(time[1]));
        this.Model.DebutJournee = Temporal.PlainDateTime.from({ year: this.DebutJournee.getFullYear(), day: this.DebutJournee.getDate(), month: this.DebutJournee.getMonth() + 1, hour: this.DebutJournee.getHours(), minute: this.DebutJournee.getMinutes() });
        this.setTimeDebutJournee();
    }

    setTimeDebutJournee() {
        this.TimeDebutJournee = `${this.DebutJournee.getHours()}:${this.DebutJournee.getMinutes()}`;
    }

    timeSetFinJournee(event: string) {
        const time = event.split(':');

        this.FinJournee = new Date();
        this.FinJournee.setHours(Number(time[0]), Number(time[1]));
        this.Model.FinJournee = Temporal.PlainDateTime.from({ year: this.FinJournee.getFullYear(), day: this.FinJournee.getDate(), month: this.FinJournee.getMonth() + 1, hour: this.FinJournee.getHours(), minute: this.FinJournee.getMinutes() });
        this.setTimeFinJournee();
    }

    setTimeFinJournee() {
        this.TimeFinJournee = `${this.FinJournee.getHours()}:${this.FinJournee.getMinutes()}`;
    }

    openPauseDialog() {

        const dialogRef = this.dialog.open(PointageBoxDialog, {
            data: {},
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.Model.PointagePauseList.push(result);
                NotificationManager.handleSuccess('Pause ajoutée', this.snackBar);
            }
        });
    }

    deletePause(p: PointagePause) {
        _.remove(this.Model?.PointagePauseList!, p);
        NotificationManager.handleSuccess('Pause suprimée', this.snackBar);
    }

    getVehicule() {
        this.pointageService.getVehicule().subscribe(x => {
            if (x) {
                this.Model.Vehicule = x;
            } else {
                NotificationManager.handleSuccess('Aucun historique disponible !', this.snackBar);
            }
        })
    }

    save() {
        this.pointageService.putPointage(this.Model).subscribe(x => {
            NotificationManager.handleSuccess('Pointage enregistré', this.snackBar);
        });
    }
}
